// extracted by mini-css-extract-plugin
export var label = "_kx-2";
export var slideContainer = "_kx-0";
export var slider = "_kx-1";